<template>
  <div class="sky-step-view-test-case">
    <!-- <div class="group_tip flex-row">
      <img width="64" height="64" src="@/assets/images/testCase.svg" />
      <div class="text_wrapper flex-col justify-between">
        <span class="text_recommend">请筛选您要进行测试的用例,推荐使用:{{ recommended }}</span>
        <div>
          <span class="text_recommend_content">
            根据需求调研输出测试用例 <span class="test-case-stat">{{ totalFeatureTestCaseCount }} </span>个，产品版本
            <span class="test-case-stat"> {{ versions.length }} </span>个，
            <span v-for="(version, index) in versions" v-bind:key="index">
              <template v-if="index !== 0">，</template>
              {{ version.productVersion }} 用例数<span class="test-case-stat"> {{ version.testCaseCount }} </span>覆盖
              <span class="test-case-stat"
                >{{ calculatePercentage(getTestCaseCountByVersion(version.productVersion)) }}% </span
              >需求
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="flex-row" style="margin-top: 18px;">
      <span class="select_text" style="width: 100px;">选择产品版本:</span>
      <el-radio-group v-model="radio" @change="handleRadioChange">
        <div
          v-for="(version, index) in versions"
          :key="index"
          style="display: inline-block;position: relative;margin-right: 24px;"
        >
          <el-badge :value="version.testCaseCount" type="primary">
            <el-radio :label="version.productVersion" style="margin-right: 12px;">{{
              version.productVersion
            }}</el-radio>
          </el-badge>
        </div>
        <div style="display: inline-block;position: relative;margin-right: 24px;">
          <el-badge :value="testCaseIdList.length" type="primary"
            ><el-radio label="all" style="margin-right: 12px;">全部</el-radio></el-badge
          >
        </div>
      </el-radio-group>
    </div> -->

    <div class="test-case-content">
      <div class="page-case-toolbar">
        <el-button icon="el-icon-refresh" class="toolbar-left" @click="refreshTable"></el-button>
        <el-input
          class="toolbar-left select-input"
          @change="selectKeyChange"
          @blur="selectKeyChange"
          v-model="selectKey"
          placeholder="请输入用例名称"
        ></el-input>
        <div class="toolbar-left select-tips">
          已选择产品版本
          <span class="bg-red font-size-16 wsp-padding-lr-6 font-weight-700">{{ productName }}</span>
          总计
          <span class="bg-red font-size-16 wsp-padding-lr-6 font-weight-700">{{ pageTotal }}</span>
          已选择
          <span class="bg-3bb113 font-size-16 wsp-padding-lr-6 font-weight-700">{{ outCont }}</span>
          输出到测试方案
          <span class="bg-red font-size-16 wsp-padding-lr-6 font-weight-700">(相同功能的测试用例将合并)</span>
        </div>
        <el-pagination
          class="toolbar-right"
          @size-change="handleSizeChange"
          @prev-click="handelPrev"
          @next-click="handelNext"
          :page-sizes="[5, 10, 20, 50, 100]"
          layout="total,sizes,prev,sp,next"
          :current-page="page"
          :page-size="pageSize"
          :total="pageTotal"
        >
        </el-pagination>
      </div>
      <el-table
        ref="test_case_table_content"
        :data="testCaseList"
        he
        :column-drag-sortable="false"
        @select-all="handleSelectionAllChange"
        @select="handleSelectionRowChange"
      >
        <el-table-column type="selection" width="55" :selectable="selectable"> </el-table-column>
        <el-table-column :label="$t('testcaseMng.testCaseName')" show-overflow-tooltip prop="testCaseName">
          <template slot-scope="scope">
            <span class="sk-link--normal" @click="showTestCaseDetail(scope.row)">{{ scope.row.testCaseName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('testcaseMng.testCaseCategory')" prop="testCaseCategory" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.testCaseCategory === 'NORMAL'" type="primary">
              {{ dictionary['testCaseCategory'][scope.row.testCaseCategory]['label'] }}
            </el-tag>
            <el-tag v-else-if="scope.row.testCaseCategory === 'SHARED'" type="success">
              {{ dictionary['testCaseCategory'][scope.row.testCaseCategory]['label'] }}
            </el-tag>
            <el-tag v-else type="danger">未知来源</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('testcaseMng.testCaseType')" prop="testCaseType" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.testCaseType === 'BUSINESS'" type="primary">功能用例</el-tag>
            <el-tag v-else-if="scope.row.testCaseType === 'PERIPHERAL'" type="success">外设用例</el-tag>
            <el-tag v-else-if="scope.row.testCaseType === 'SOFTWARE'" type="warning">软件用例</el-tag>
            <el-tag v-else-if="scope.row.testCaseType === 'PERIPHERAL_COLLECT'" type="success">外设用例</el-tag>
            <el-tag v-else-if="scope.row.testCaseType === 'SOFTWARE_COLLECT'" type="warning">软件用例</el-tag>
            <el-tag v-else type="warning">未知类型</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('testcaseMng.featureName')" width="350" show-overflow-tooltip prop="featureName">
        </el-table-column>
        <el-table-column :label="$t('testcaseMng.featureType')" prop="featureType" width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.featureType === 'REQUIRED'" type="danger">必选</el-tag>
            <el-tag v-else-if="scope.row.featureType === 'RECOMMEND'" type="primary">推荐</el-tag>
            <el-tag v-else type="success">可选</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('testcaseMng.testProductVersion')"
          prop="testProductVersion"
          width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column :label="$t('testcaseMng.testCaseScene')" prop="sceneName" show-overflow-tooltip>
        </el-table-column>
        <el-table-column :label="$t('testcaseMng.operation')" width="115"
          ><div class="wsp-display-flex" slot-scope="scope" @click="handleAddTestCase(scope.row)">
            <div class="sk-link--normal" v-if="scope.row.testCaseType === 'BUSINESS'">
              {{ $t('testcaseMng.addTestCase.feature') }}
            </div>
            <div class="sk-link--normal" v-else-if="scope.row.testCaseType === 'PERIPHERAL'">
              {{ $t('testcaseMng.addTestCase.peripheral') }}
            </div>
            <div class="sk-link--normal" v-else-if="scope.row.testCaseType === 'SOFTWARE'">
              {{ $t('testcaseMng.addTestCase.software') }}
            </div>
            <div class="sk-link--normal" v-else-if="scope.row.testCaseType === 'PERIPHERAL_COLLECT'">
              {{ $t('testcaseMng.addTestCase.peripheral') }}
            </div>
            <div class="sk-link--normal" v-else-if="scope.row.testCaseType === 'SOFTWARE_COLLECT'">
              {{ $t('testcaseMng.addTestCase.software') }}
            </div>
            <div class="sk-link--normal" v-else>{{ $t('testcaseMng.addTestCase.def') }}</div>
          </div>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { Radio, RadioGroup, Table, TableColumn, Pagination, Input, Button, Tag, Badge } from 'element-ui'
import { extend } from 'sk-ui/lib/utils/util.js'
import { action } from 'sky-engine/api'

import { PRODUCT_MNG } from '@/api/apiModules'
import { getDetail } from '@/api/project'
import { getInstStatistics, setInstExport, getInstList } from '@/api/testcase'
import caseRepo from '@/store/modules/caseRepo/metaData/caseRepo'
import tcDetail from '@/store/modules/pocMng/metaData/testcase/tcDetail'
import dictionary from '@/utils/dictionary'
import { isDeepEqual } from '@/utils/pageUtils'

export default {
  name: 'SkyStepViewTestCaseDetail',
  props: {
    projectId: {
      type: String,
      default() {
        return null
      }
    }
  },
  components: {
    [Button.name]: Button,
    [Input.name]: Input,
    [Radio.name]: Radio,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [RadioGroup.name]: RadioGroup,
    [Pagination.name]: Pagination,
    [Tag.name]: Tag,
    [Badge.name]: Badge
  },
  data() {
    return {
      versions: [],
      vaersionMap: {
        all: {
          testCaseList: [],
          testCaseCount: 0
        }
      },
      outCont: 0,
      recommended: null,
      recommendedId: null,
      radio: null,
      reqParams: {
        projectId: this.projectId
      },
      cachesSelectId: [],
      selectKey: null,
      selectedVersion: [],
      selectTestCase: [],
      testCaseList: [],
      totalFeatureTestCaseCount: 0, //总用例个数
      versionTestCaseCounts: {}, // 存储每个版本对应的测试用例数量
      recommendedVersion: null, // 推荐版本号,
      recommendedValue: {
        testCaseCount: 0
      },
      pageTotal: 0,
      pageSize: 20,
      page: 1,
      tempData: {},
      oldData: {},
      dictionary: dictionary,
      testCaseIdList: [],
      allVersion: null,
      productName: null
    }
  },
  created() {
    this.$emit('openChangeDialog', { projectId: this.projectId })
    this.getInitData()
    this.$emit('showBtns', {
      preStep: false,
      nextStep: true,
      saveStep: false,
      enableTabChange: true
    })
    getDetail({ id: this.projectId }).then(res => {
      this.productName = res.data.content.productName
    })
    //this.getTableData()
  },
  mounted() {},
  methods: {
    showTestCaseDetail(rowData) {
      const tcDetailCopy = extend(true, {}, tcDetail)
      tcDetailCopy.view.tabs[0].viewMetaData.view.content[0].title = rowData.testCaseName
      const props = {}
      props.params = {
        id: rowData.testCaseId
      }
      this.$store.dispatch('OpenDetailDialog', {
        metaData: tcDetailCopy,
        props,
        clone: false
      })
    },
    handleAddTestCase(rowParams) {
      const testCaseIdList = this.testCaseIdList
      const props = {
        params: { testCaseType: rowParams.testCaseType },
        extraParams: {
          refreshParent: this.refreshAll,
          sourceTestCaseId: rowParams.id,
          testCaseType: rowParams.testCaseType,
          recommendedId: this.recommendedId
        },
        allowStatus: {
          TestCaseSharedEdit: { owner: [true] },
          TestCaseSharedDelete: { owner: [true] },
          TestCaseSharedCopy: { relevant: ['SPEC'] },
          testCaseSharedAdd: {
            expression: function(row, meta) {
              return !testCaseIdList.includes(row.id)
            }
          }
        }
      }
      if (rowParams.testCaseType === 'PERIPHERAL_COLLECT') {
        props.params.testCaseType = 'PERIPHERAL'
      }
      if (rowParams.testCaseType === 'SOFTWARE_COLLECT') {
        props.params.testCaseType = 'SOFTWARE'
      }
      const caseRepoList = extend(true, {}, caseRepo)
      for (let idx = caseRepoList.view.columns.length - 1; idx >= 0; idx--) {
        let column = caseRepoList.view.columns[idx]
        if (column?.props?.prop === 'testCaseCode') {
          caseRepoList.view.columns.splice(idx, 1)
        }
        if (column?.props?.prop === 'testCaseScene') {
          caseRepoList.view.columns.splice(idx, 1)
        }

        if (column?.dataType === 'operation') {
          column.props.showBtnNum = '1'
        }
      }
      caseRepoList.toolbar.items[0].action = 'TestCaseSharedCreateByCondition'
      caseRepoList.view.menus = [
        {
          icon: 'sk-icon-sure',
          label: '选择',
          command: 'TestCaseSharedAdd',
          name: 'testCaseSharedAdd',
          tip: '该用例已被选择'
        },
        {
          icon: 'sk-icon-copy',
          label: '复制',
          command: 'TestCaseSharedCopy',
          name: 'TestCaseSharedCopy',
          tip: '通用用例不支持复制'
        }
      ]
      this.$store.dispatch('OpenDetailDialog', {
        metaData: caseRepoList,
        props,
        clone: false
      })
    },
    selectable(row, index) {
      return row.featureType !== 'REQUIRED'
    },

    refreshTable() {
      this.getTableData()
    },
    refreshAll(testCaseId) {
      this.getInitData(testCaseId)
    },
    getTableData(testcaseId) {
      var req_data = {
        exactMatchArr: [],
        matchArr: [
          {
            type: 'EXACT',
            fieldName: 'projectId',
            valueArr: [this.projectId],
            matchRule: 'EQ'
          }
        ],
        sortArr: [],
        page: this.page - 1,
        limit: this.pageSize
      }

      if (this.selectKey) {
        req_data.matchArr.push({
          type: 'FUZZY',
          fieldNameArr: ['testCaseName'],
          value: this.selectKey,
          matchRule: 'FULL'
        })
      }

      getInstList(req_data).then(res => {
        this.testCaseList = res.data.content.itemArr
        this.$nextTick(() => {
          for (const iterator of this.testCaseList) {
            if (this.vaersionMap[this.recommendedVersion].testCaseList.includes(iterator.id)) {
              this.$refs.test_case_table_content.toggleRowSelection(iterator, true)
            }
          }
        })

        this.pageTotal = res.data.content.total
      })

      var req_all_data = {
        exactMatchArr: [],
        matchArr: [
          {
            type: 'EXACT',
            fieldName: 'projectId',
            valueArr: [this.projectId],
            matchRule: 'EQ'
          }
        ],
        sortArr: [],
        page: 0,
        limit: 1000
      }
      getInstList(req_all_data).then(res => {
        this.testCaseIdList = res.data.content.itemArr.map(item => item.testCaseId)
        if (testcaseId) {
          for (const data of res.data.content.itemArr) {
            if (data.testCaseId == testcaseId) {
              !this.vaersionMap[data.testProductVersion].testCaseList.includes(data.id) &&
                this.vaersionMap[data.testProductVersion].testCaseList.push(data.id)
              !this.vaersionMap['all'].testCaseList.includes(data.id) &&
                this.vaersionMap['all'].testCaseList.push(data.id)
              for (const tableData of this.testCaseList) {
                if (tableData.id == data.id) {
                  const tempIdList = this.selectTestCase.map(item => item.id)
                  !tempIdList.includes(data.id) && this.selectTestCase.push(data)
                }
              }
            }
          }
        }
      })
    },
    selectKeyChange() {
      this.page = 1
      this.getTableData()
    },
    getInitData(testcaseId) {
      this.vaersionMap = {}
      this.vaersionMap['all'] = {
        testCaseList: [],
        testCaseCount: 0
      }
      this.recommendedVersion = 'all'
      getInstStatistics({ projectId: this.projectId }).then(res => {
        if (res.status === 200 && res.data && res.data.content && res.data.content.length > 0) {
          this.totalFeatureTestCaseCount = res.data.content[0].totalFeatureTestCaseCount || 0
          this.versions = res.data.content.map(item => item)

          this.vaersionMap['all'] = {
            testCaseList: [],
            testCaseCount: 0
          }

          var hasSelect = false
          var list = []
          for (const iterator of this.versions) {
            this.vaersionMap[iterator.productVersion] = iterator
            for (const caseId of iterator.testCaseList) {
              if (!this.vaersionMap['all'].testCaseList.includes(caseId)) {
                this.vaersionMap['all'].testCaseList.push(caseId)
              }
            }

            if (iterator.selected) {
              list.push(iterator)
            }
            if (iterator.selected && !hasSelect) {
              hasSelect = true
            }
          }
          this.versionTestCaseCounts = res.data.content.reduce((acc, item) => {
            acc[item.productVersion] = item.testCaseCount
            return acc
          }, {})

          const maxTestCaseCountItem = res.data.content.reduce((prev, current) =>
            prev.testCaseCount >= current.testCaseCount ? prev : current
          )
          this.recommended = maxTestCaseCountItem.productVersion
          action(PRODUCT_MNG, 'findAllActive').then(response => {
            for (const item of response.data.content.itemArr) {
              if (item.productVersion == this.recommended) {
                this.recommendedId = item.id
                break
              }
            }
          })

          this.recommendedVersion = 'all'
          this.radio = this.recommendedVersion
          this.selectedVersion = [this.recommendedVersion]

          this.outCont = this.vaersionMap[this.recommendedVersion].testCaseList.length
          this.allVersion = this.versions.map(item => item.productVersion).join(',')

          this.getTableData(testcaseId)
          this.recommendedValue = this.vaersionMap[this.recommendedVersion]
          this.tempData = this.getSimpleData()
          this.oldData = this.getSimpleData()
        }
      })
    },
    getTestCaseCountByVersion(version) {
      return this.versionTestCaseCounts[version] || 0
    },
    calculatePercentage(testCaseCount) {
      if (this.totalFeatureTestCaseCount === 0) {
        return '100.00' //处理为0的情况
      } else {
        return ((testCaseCount / this.totalFeatureTestCaseCount) * 100).toFixed(2)
      }
    },
    // size 变更 每页条数
    handleSizeChange(val) {
      this.pageSize = val
      this.page = 1
      this.getTableData()
    },
    //
    handleSelectionChange(val) {
      this.selectTestCase = val
    },
    handleSelectionAllChange(selection) {
      if (selection.length > 0) {
        for (const iterator of this.testCaseList) {
          var select = this.vaersionMap[this.recommendedVersion].testCaseList.includes(iterator.id)
          var newSelect = selection.filter(item => item.id === iterator.id)
          if (!select && newSelect.length > 0) {
            this.vaersionMap[this.recommendedVersion].testCaseList.push(iterator.id)
            this.outCont = this.vaersionMap[this.recommendedVersion].testCaseList.length
          } else if (select && newSelect.length > 0) {
            console.log('啥也不干')
          } else {
            var indexx = this.vaersionMap[this.recommendedVersion].testCaseList.indexOf(iterator.id)
            if (indexx > -1) {
              this.vaersionMap[this.recommendedVersion].testCaseList.splice(indexx, 1)
            }
            this.outCont = this.vaersionMap[this.recommendedVersion].testCaseList.length
          }
        }
      } else {
        for (const iterator of this.testCaseList) {
          if (this.vaersionMap[this.recommendedVersion].testCaseList.includes(iterator.id)) {
            var indexb = this.vaersionMap[this.recommendedVersion].testCaseList.indexOf(iterator.id)
            if (indexb > -1) {
              this.vaersionMap[this.recommendedVersion].testCaseList.splice(indexb, 1)
            }
            this.outCont = this.vaersionMap[this.recommendedVersion].testCaseList.length
          }
        }
      }
    },
    handleSelectionRowChange(val, row) {
      this.selectTestCase = val
      const exists = val.some(obj => obj.id === row.id)
      if (exists) {
        if (!this.vaersionMap[this.recommendedVersion].testCaseList.includes(row.id)) {
          this.vaersionMap[this.recommendedVersion].testCaseList.push(row.id)
          this.outCont = this.vaersionMap[this.recommendedVersion].testCaseList.length
        }
      } else {
        var newList = this.vaersionMap[this.recommendedVersion].testCaseList.filter(item => item !== row.id)
        this.vaersionMap[this.recommendedVersion].testCaseList = newList
        this.outCont = newList.length
      }
      this.validateDataChange()
    },
    handelPrev() {
      this.page -= 1
      this.getTableData()
    },
    handelNext() {
      this.page += 1
      this.getTableData()
    },
    validateDataChange() {
      var save_req = this.getSimpleData()

      var equal = isDeepEqual(this.oldData, save_req)
      if (!equal) {
        this.$emit('showBtns', {
          preStep: false,
          nextStep: false,
          saveStep: true,
          enableTabChange: true
        })
      } else {
        this.$emit('showBtns', {
          preStep: false,
          nextStep: false,
          saveStep: false,
          enableTabChange: true
        })
      }
    },
    handleRadioChange(value) {
      this.radio = value
      this.recommendedVersion = value
      this.recommendedValue = this.vaersionMap[this.recommendedVersion]
      this.outCont = this.vaersionMap[this.recommendedVersion].testCaseList.length
      const version = value

      if (version === 'all') {
        this.selectedVersion = []
      } else {
        this.selectedVersion = [version]
      }
      this.getTableData()
      this.validateDataChange()
    },
    async saveStep() {
      this.message = '点击了保存'
      var data = this.vaersionMap[this.recommendedVersion].testCaseList
      let pv = ''
      if (this.recommendedVersion === 'all') {
        this.versions.forEach(item => {
          pv += item.productVersion + ','
        })
        pv = pv.slice(0, -1)
      } else {
        pv = this.recommendedVersion
      }

      var reqData = {
        testCaseIdList: data,
        projectId: this.projectId,
        productVersion: pv
      }
      var result = false
      await setInstExport(reqData)
        .then(res => {
          if (res.data.status === 'SUCCESS') {
            this.tempData = this.getSimpleData()
            result = true
          }
        })
        .catch(e => {
          result = false
        })
      this.validateDataChange()
      return result
    },
    getData() {
      this.message = '缓存数据'
      var reqData = this.getSimpleData()
      var busData = this.getTempData()

      var equal = isDeepEqual(this.tempData, reqData)
      if (equal) {
        return {
          dataChange: false
        }
      } else {
        this.tempData = reqData
        return {
          dataChange: true,
          busDATA: busData
        }
      }
    },
    getSimpleData() {
      var simple_data = {
        recommendedVersion: this.recommendedVersion,
        versionMap: {}
      }
      for (let key in this.vaersionMap) {
        simple_data.versionMap[key] = {
          testCaseIdList: this.vaersionMap[key].testCaseList
        }
      }
      return simple_data
    },
    getTempData() {
      var reqData = []
      for (let key in this.vaersionMap) {
        if ('all' === key) {
          continue
        }
        var value = this.vaersionMap[key]
        value.selected = this.recommendedVersion === 'all' ? true : value.selected
        reqData.push(value)
      }
      return reqData
    },
    async gotoNextPreVliate() {
      return true
    },
    async gotoNextStep() {
      this.message = '点击了下一步'
      var data = this.vaersionMap[this.recommendedVersion].testCaseList
      let pv = ''
      if (this.recommendedVersion === 'all') {
        this.versions.forEach(item => {
          pv += item.productVersion + ','
        })
        pv = pv.slice(0, -1)
      } else {
        pv = this.recommendedVersion
      }

      var reqData = {
        testCaseIdList: data,
        projectId: this.projectId,
        productVersion: pv
      }

      var result = true
      await setInstExport(reqData)
        .then(res => {
          if (res.data.status === 'SUCCESS') {
            this.tempData = this.getSimpleData()
            return true
          }
        })
        .catch(e => {
          result = false
        })
      return result
    },
    gotoPreStep() {
      this.message = '点击了上一步'
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(step-view-test-case) {
  height: 100%;
  overflow-y: scroll;
  .test-case-content {
    height: 576px;
    .page-case-toolbar {
      padding-top: 12px;
      .select-input {
        width: 15%;
        padding: 0 3px;
      }
      .select-tips {
        line-height: 28px;
        padding: 0 24px;
      }
      .toolbar-left {
        float: left;
      }
      .toolbar-right {
        float: right;
      }
    }
  }
}
.group-buttom {
  height: 128px;
}
.content {
  width: 100%;
  height: 300px;
  overflow: hidden;
}
.group_tip {
  background-color: rgba(255, 255, 255, 1);
  width: 99%;
  border: 1px solid rgba(239, 239, 239, 1);
  padding: 6px;
}

.red-dot {
  position: absolute;
  top: -12px;
  right: -12px;
  width: 16px;
  height: 16px;
  background-color: #409eff;
  color: #fff;
  border-radius: 50%;
}

.text_wrapper {
  height: 100%;
  margin: 0 24px;
}

.text_recommend {
  height: 28px;
  overflow-wrap: break-word;
  color: rgb(29, 29, 29);
  font-size: 20px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  line-height: 28px;
}

.text_recommend_content {
  height: 24px;
  overflow-wrap: break-word;
  color: rgba(126, 126, 126, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  line-height: 24px;
}

.select_text {
  color: rgba(91, 91, 91, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
}

.version_text {
  width: 127px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.72);
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 5px;
}
.test-case-stat {
  color: blue;
  font-weight: bold;
}
</style>
